const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const GiftVoucherQuery: any = {
    GetGiftVouchers: Backofficebff + '/v1/campaignmanagement/getGiftVouchers',
    PostGiftVoucher: Backofficebff + '/v1/campaignmanagement/saveGiftVoucher',
    UpdateGiftVoucherStatus: Backofficebff + '/v1/campaignmanagement/updateGiftVoucherStatus',
    GetGiftVoucherById: Backofficebff + '/v1/campaignmanagement/getGiftVoucher',
};
